import React from 'react';
import ReactDOM from 'react-i18next'; // Actually, need react-dom
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Import i18n setup

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
